import { cn } from '@/lib/cn';

export type StatusTone = 'ready' | 'preparing' | 'attention' | 'idle';

const TONE = {
  ready: 'bg-up',
  preparing: 'bg-accFill',
  attention: 'bg-down',
  idle: 'bg-line2',
} satisfies Record<StatusTone, string>;

/** 6px status dot. Colour transitions in place so a track turning ready is seen. */
export function StatusDot({ tone, className }: { tone: StatusTone; className?: string }) {
  return (
    <span
      aria-hidden="true"
      data-tone={tone}
      className={cn('inline-block h-1.5 w-1.5 shrink-0 rounded-full transition-colors duration-300', TONE[tone], className)}
    />
  );
}
